import { AlphaQCircleIcon } from './AlphaQCircleIcon';

/**
 * author: Contributors
 * id 03AA79A3-ADEF-4B0E-8023-455FAD721515
 * name alpha-q-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-q-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterQCircleIcon = AlphaQCircleIcon;
export default LetterQCircleIcon